import contract from "../../../config/realtime_contract.json"

export const FRIEND_STATE_VERSION = contract.friendState.version
export const FRIEND_STATE_FIELDS = Object.freeze([...contract.friendState.fields])
export const TERMINAL_TRIP_STATE_CODES = Object.freeze([...contract.tripState.terminalErrorCodes])

const FRIEND_STATE_FIELD_SET = new Set(FRIEND_STATE_FIELDS)

// Project at the HTTP boundary so an accidental server-only field cannot become
// a fourth, undocumented browser friend-state API.
export function projectFriendState(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {}
  return Object.fromEntries(
    Object.entries(value).filter(([field]) => FRIEND_STATE_FIELD_SET.has(field))
  )
}
